import useStableObjectReference from 'hooks/useStableObjectReference'
import usePrevious from 'hooks/usePrevious'
import { hasMerchandiseFilterChanged } from 'analytics/mapMerchandiseSearchTracking'

function useMerchandiseFilterWasApplied(currentFilters: App.MerchandiseFilters): boolean {
  const stableFilters = useStableObjectReference(currentFilters)
  const previousFilters = usePrevious(stableFilters)

  if (!previousFilters) return false

  return hasMerchandiseFilterChanged({ currentFilters: stableFilters, previousFilters })
}

export default useMerchandiseFilterWasApplied
